/**
 * @Author : zhouqinze
 * @Date : 2019-12-30
 * @Version : 1.0
 * @Content : 公司文化
 **/
<template>
    <div class="aboutBox">
        <div class="banner"></div>
        <div class="content">
            <SynopsisTab :TextArr="['员工关怀','员工活动','职业发展','加入我们']" :routerArr="['/comculture/care','/comculture/activity','/comculture/grow','/comculture/joinus']" />
            <div class="aboutCom">
                <router-view></router-view>
            </div>
        </div>
    </div>
</template>
<script>
import SynopsisTab from '../components/SynopsisTab'
export default {
    components:{
        SynopsisTab
    }
}
</script>
<style lang="scss" scoped>
    .aboutBox{
        width: 100%;
        .banner{
            width: 100%;
            height: 23.8125rem;
            background: url(http://comit.oss-cn-hangzhou.aliyuncs.com/img/img_banner_qywh.png) no-repeat center center;
            background-size: 100% 100%;
        }
        .content{
            width: 1200px;
            height: 100%;
            margin: auto;
            display: flex;
            justify-content: space-between;
            .aboutCom{
                width: 75%;
                padding-top: 4.9375rem;
                box-sizing: border-box;
                margin-bottom: 3.3125rem;
            }
        }
    }
</style>